import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router";
import moment from "moment";
import { Form } from "antd";
import { IPoliciesContext } from "../../context/PoliciesContext/types";
import { PoliciesContext } from "../../context/PoliciesContext/PoliciesContext";
import { useAppDispatch, useAppSelector } from "../../../..";
import { PoliciesList } from "../PoliciesList/PoliciesList";
import {
  fetchPoliciesActionsDic,
  fetchPoliciesContextsDic,
  fetchPoliciesEntityObjectTypeDic,
  fetchPoliciesStatusDic,
  fetchPoliciesTypesDic,
  searchPolicies,
} from "../../store/slice/policiesSlice";
import { IPoliciesListSearch } from "../../types/IPoliciesListSearch";
import { toHttpFormatStartOfDay } from "../../../../lib/utils";
import { PolicyCreate } from "../PolicyCreate/PolicyCreate";
import {
  fetchPaymentType,
  fetchProducts,
  fetchTariffModelTypes,
} from "../../../../store/slices/rtkDictionaries";
import { fetchServiceTypeList } from "../../../../store/slices/offering/offering";
import { PolicyView } from "../PolicyView/PolicyView";
import { fetchOfferingGroupsTypesDic } from "../../store/slice/offeringGroupsSlice";
import { useDispatchWithCheck } from "../../../../lib/hooks/useDispatchWithCheck";
import { fetchOfferingStatuses } from "../../../../store/slices/dicts";
import "./PoliciesContainer.less";

export const PoliciesContainer = () => {
  const dispatch = useAppDispatch();

  const { dispatchWithCheck } = useDispatchWithCheck();

  const { productsLoading, tariffModelTypesLoading, paymentTypeLoading } = useAppSelector(
    (state) => state.rtkDictionaries
  );
  const { offeringStatusesLoading } = useAppSelector((state) => state.dicts);
  const { serviceTypeListLoading } = useAppSelector((state) => state.offering);
  const { offeringGroupsTypesDicLoading } = useAppSelector((state) => state.offeringGroups);
  const {
    policiesTypesDicLoading,
    policiesContextsDicLoading,
    policiesActionsDicLoading,
    policiesStatusDicLoading,
    policiesEntityObjectTypeLoading,
  } = useAppSelector((state) => state.policies);

  // Загрузка справочников
  useEffect(() => {
    dispatchWithCheck(fetchPoliciesTypesDic(), policiesTypesDicLoading);
    dispatchWithCheck(fetchPoliciesActionsDic(), policiesActionsDicLoading);
    dispatchWithCheck(fetchPoliciesContextsDic(), policiesContextsDicLoading);
    dispatchWithCheck(fetchPoliciesStatusDic(), policiesStatusDicLoading);
    dispatchWithCheck(fetchPoliciesEntityObjectTypeDic(), policiesEntityObjectTypeLoading);
    dispatchWithCheck(fetchOfferingGroupsTypesDic(), offeringGroupsTypesDicLoading);
    dispatchWithCheck(fetchProducts(), productsLoading);
    dispatchWithCheck(
      fetchServiceTypeList({
        onDate: toHttpFormatStartOfDay(moment()),
        includeFutureDates: true,
        includePastDates: false,
      }),
      serviceTypeListLoading
    );
    dispatchWithCheck(fetchTariffModelTypes(), tariffModelTypesLoading);
    dispatchWithCheck(fetchOfferingStatuses(), offeringStatusesLoading);
    dispatchWithCheck(fetchPaymentType(), paymentTypeLoading);
  }, []);

  const [isSearchOpen, setIsSearchOpen] = useState(true);
  const toggleSearchOpen = () => {
    setIsSearchOpen((prev) => !prev);
  };

  const [policiesListSearchForm] = Form.useForm<IPoliciesListSearch>();

  const handlePoliciesListSearch = (params?: { page?: number; size?: number }) => {
    const page = params?.page || 0;
    const size = params?.size || 7;
    const values: IPoliciesListSearch = policiesListSearchForm.getFieldsValue();
    if (values.assocObjectName) {
      values.assocTypeAlias = policiesListSearchForm.getFieldValue("assocTypeAlias");
      values.assocObjectId = policiesListSearchForm.getFieldValue("assocObjectId");
      delete values.assocObjectName;
    }
    if (values.actorName) {
      values.actorTypeAlias = policiesListSearchForm.getFieldValue("actorTypeAlias");
      values.actorId = policiesListSearchForm.getFieldValue("actorId");
      delete values.actorName;
    }
    const onDate = toHttpFormatStartOfDay(values.onDate);
    dispatch(searchPolicies({ ...values, onDate, page, size }));
  };

  const contextValue: IPoliciesContext = {
    isSearchOpen,
    toggleSearchOpen,
    handlePoliciesListSearch,
    policiesListSearchForm,
  };

  return (
    <PoliciesContext.Provider value={contextValue}>
      <div className="container_height inner-row policies-container">
        <Switch>
          {/* <Route exact path="/policies">
            <Redirect to="/policies/list" />
          </Route> */}
          <Route path="/policies" exact>
            <PoliciesList />
          </Route>
          <Route path="/policies/create">
            <PolicyCreate />
          </Route>
          <Route path="/policies/:policyId">
            <PolicyView />
          </Route>
          {/* <Route path="/offer/create">
            {hasAccess(MENU_ADMIN_OFFERING_WRITE) ? <OfferCreateContainer /> : <AccessForbidden />}
          </Route>
          <Route path="/offer/:offerId">
            <OfferParamsContainer />
            <TarificationParamsContainer />
            <ServiceProfileContainer />
            {hasLocalAccess("offering.groupOffer") && <GroupOfferContainer />}
          </Route> */}
        </Switch>
      </div>
    </PoliciesContext.Provider>
  );
};
